<template>
  <div>
    <partners-table/>
  </div>
</template>

<script>
import PartnersTable from '@/components/app/partners/PartnersTable'

export default {
  components: {
    PartnersTable
  },
  name: "Partners"
}
</script>

<style scoped>

</style>